import {main} from "../node_modules/ken-js/src/JS/index.js";
import data from "./data.json"

export const db = main(data);